import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/documentHistory/getters";
import { actions } from "@/store/modules/documentHistory/actions";
import { mutations } from "@/store/modules/documentHistory/mutations";
import {
  IDocumentHistoryState,
  state,
} from "@/store/modules/documentHistory/state";

export const documentHistory: Module<IDocumentHistoryState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
